import { EditOutlined } from "@mui/icons-material";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  IconButton,
  Stack,
  Tooltip,
  Button,
} from "@mui/material";
import * as React from "react";
import Loader from "../../components/Loader";
import useHotlyncServices from "./services-hooks";
import HotlyncServicesForm from "./service-form";
import SyncIcon from '@mui/icons-material/Sync';

const Services = () => {
  const {
    Services,
    handleClickEditOpen,
    editData,
    handleEditClose,
    open,
    propertyId,
    refetchHotlyncService,
    setOpen,
    loadingServices,
    syncHotlyncServices
  } = useHotlyncServices();

  if (loadingServices) {
    return <Loader />;
  }

  return (
    <>
      <Grid container alignItems={"center"} spacing={2} mb={2}>
        <Grid item>
          <Typography variant="h4" fontWeight={600}>
            Service Management
          </Typography>
        </Grid>
        <Grid item display={"flex"} alignItems={"stretch"}>
          <Button
            size="large"
            disableElevation={false}
            variant="contained"
            startIcon={<SyncIcon />}
            onClick={() => syncHotlyncServices()}
            sx={{ mr: 1 }}
          >
            Sync Hotlync Services
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={{ xs: 1, md: 2 }}>
        {Services?.map((item: any, index: any) => (
          <Grid item md={3} lg={2} key={index}>
            <Card
              sx={{
                mt: 2,
                padding: 1,
                borderRadius: 3,
                position: "relative",
                height: "100px",
              }}
            >
              <CardContent sx={{ flex: 1, p: 1.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {item.name}
                </Typography>
              </CardContent>
              <Stack direction="row" justifyContent="flex-end" spacing={1}>
                <Tooltip title="Edit" placement="top" arrow>
                  <IconButton
                    onClick={() => handleClickEditOpen(item)}
                    color="info"
                    aria-label="edit"
                  >
                    <EditOutlined />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Card>
          </Grid>
        ))}
        {/* Edit Dialog */}
        <HotlyncServicesForm
          editData={editData}
          handleEditClose={handleEditClose}
          open={open}
          propertyId={propertyId}
          refetch={refetchHotlyncService}
          setOpen={setOpen}
        />
      </Grid>
    </>
  );
};

export default Services;
